// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const AuditStatusTcsm = t.struct({
    compl24Months: t.maybe(t.Number),
    due3Months: t.maybe(t.Number),
    overdue: t.maybe(t.Number),
    tcsmName: t.String,
    userId: t.String
}, {
    name: 'AuditStatusTcsm',
    strict: true
});

export const getDefaultState = () => new AuditStatusTcsm({
    compl24Months: null,
    due3Months: null,
    overdue: null,
    tcsmName: '',
    userId: ''
});

export default AuditStatusTcsm;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/audit-status-tcsm.js